import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = (props) => {
    return (
        <section className={`text-center py-16 ${props.hclass}`}>
            <div className="container mx-auto px-4">
                <div className="max-w-3xl mx-auto">
                    <h2 className="cta-custom-h2">Invest in the Future of Pharmacy</h2>
                    <p className="cta-custom-p">Join Pharmacy Freedom Fund in revolutionizing the independent pharmacy sector. Our strategic approach combines targeted acquisitions, operational optimization, and cutting-edge technology integration to unlock hidden value. With a proven track record of generating substantial returns, we offer investors a unique opportunity to capitalize on the evolving healthcare landscape. Our expert team identifies undervalued pharmacies, implements efficient management practices, and leverages economies of scale to drive profitability. By investing with us, you're not just funding pharmacies; you're supporting community health while positioning yourself for attractive financial returns in a stable, growing market</p>
                    <a href="https://portal.pharmacyfreedomfund.com/" className="theme-btn-s2">
                        Invest Now
                    </a>
                </div>
            </div>
        </section>
    )
}

export default CTASection;

